"use client";

import LoginScreen from "@/app/_components/Auth/LoginScreen";

export default function LoginPage() {
  return <LoginScreen />;
}
